module.exports = __webpack_public_path__ + "304aab846d75f9bf87189cd48cdf752d.fbx";